<template>
  <router-link :to="'/match/' + item.id" id="match">
    <div class="team">
      <cld-image
        class="logo"
        :publicId="item.local_team.shield"
        type="fetch"
        loading="lazy"
      >
        <cld-transformation
          height="100"
          radius="3"
          crop="fill"
          fetchFormat="auto"
        />
      </cld-image>

      <div class="name">{{ item.local_team.name }}</div>
    </div>
    <div class="meta">
      <div class="competition">
        <!-- {{ categories[item.category].groups[item.group].rounds }} -->
        <span class="category">{{ categories[item.category].name }}</span>
        <template v-if="item.group">
          <span class="group"
            >{{ $t("miclive.competition.group") }}
            {{ categories[item.category].groups[item.group].name }}</span
          >
          <span class="round">{{
            $t(
              categories[item.category].groups[item.group].rounds[item.round]
                .name
            )
          }}</span>
        </template>
        <template v-else-if="item.phase">
          <span class="group">
            {{ $t(categories[item.category].phases[item.phase].name) }}
          </span>
          <span class="round">
            {{
              $t(
                categories[item.category].phases[item.phase].rounds[item.round]
                  .name
              )
            }}
          </span>
        </template>
        <span class="name">{{ item.name }}</span>
      </div>
      <div class="date">{{ formatDate(item.date) }}</div>
      <div class="facility">
        {{
          facilities[item.facility]
            ? facilities[item.facility].name_competition
            : ""
        }}
      </div>
      <div class="score">
        <div class="value">
          {{ item.local_team_goals ? item.local_team_goals : "-" }}

          <span v-if="item.local_team_p_goals != null" class="penalties">
            ({{ item.local_team_p_goals }})
          </span>
        </div>
        <div class="value">
          {{ item.away_team_goals ? item.away_team_goals : "-" }}

          <span v-if="item.away_team_p_goals != null" class="penalties">
            ({{ item.away_team_p_goals }})
          </span>
        </div>
      </div>
      <div class="status">{{ $t("miclive.match.status" + item.status) }}</div>
    </div>

    <div class="team">
      <cld-image
        class="logo"
        :publicId="item.away_team.shield"
        type="fetch"
        loading="lazy"
      >
        <cld-transformation
          height="100"
          radius="3"
          crop="fill"
          fetchFormat="auto"
        />
      </cld-image>
      <div class="name">{{ item.away_team.name }}</div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "Match",
  props: {
    item: Object
  },
  data() {
    return {};
  },
  computed: {
    facilities() {
      return this.$store.getters["facilities/getList"]();
    },
    categories() {
      return this.$store.getters["competition/getCategories"]();
    }
  },
  methods: {
    load() {},
    formatDate(date) {
      return moment(date, "YYYY-MM-DD HH:mm").format("ddd DD/MM HH:mm");
    }
  },
  created() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
#match {
  background-color: #fff;
  border-radius: 4px;
  padding: 5px;
  width: 100%;
  margin-bottom: 0px;
  display: flex;
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.1);
  align-items: center;
  text-decoration: none;
  color: #222;
  transition: all 0.3s;

  .team {
    width: 30%;
    text-align: center;
    .logo {
      width: 80%;
      max-width: 40px;
    }
    .name {
      font-family: $font-title;
      color: #222;
      font-size: 11px;
      margin-top: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  .meta {
    text-transform: uppercase;
    width: 40%;
    font-size: 10px;
    text-align: center;

    .competition {
      color: $main-color;
      .category {
        font-family: $font-title;
        &:after {
          content: "|";
          font-family: $font-text;
          margin: 0 2px;
        }
      }
      .group {
        font-family: $font-title;
        &:after {
          content: "|";
          font-family: $font-text;
          margin: 0 2px;
        }
      }
      .round {
        font-family: $font-title;
        &:after {
          content: "|";
          font-family: $font-text;
          margin: 0 2px;
        }
      }
      .name {
      }
    }
    .date {
      font-family: $font-title;
      color: #222;
      font-size: 12px;
    }
    .facility {
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      white-space: nowrap;
    }
    .status {
      margin-top: 10px;
      font-size: 9px;
    }
    .score {
      border-radius: 4px;
      background-color: #eee;
      display: flex;
      text-align: center;
      padding: 5px;
      width: 70%;
      margin: 4px auto;

      .value {
        width: 100%;
        font-family: $font-black;
        font-size: 20px;

        .penalties {
          font-size: 12px;
          font-family: $font-text;
          font-weight: bold;
          display: inherit;
        }
      }
    }
  }
  &:hover {
    background-color: #edffff;
  }
}

.laptop {
  #match {
    // max-width: 300px;
  }
}
</style>
